import {Nullish} from 'shared/web';

import {i18n} from '../i18n/i18n';
import {isCebiaWorkspace} from './isCebiaWorkspace';

const OIL_DROP_SUGGESTION_SEPARATOR = ' - ';
const OIL_DROP_TEST_VALUES = {
  OK: 'OK',
  REPLACEMENT_RECOMMENDED: 'REPLACEMENT_RECOMMENDED',
};

export function getOilDropTestDescription(comment: string | Nullish, value: string | Nullish) {
  const replacementSuggestion =
    value === OIL_DROP_TEST_VALUES.REPLACEMENT_RECOMMENDED
      ? i18n.t('oilDropTestReplacementSuggestion')
      : '';

  if (isCebiaWorkspace()) {
    if (comment) {
      return `${comment}${OIL_DROP_SUGGESTION_SEPARATOR}${replacementSuggestion}`;
    }
    return replacementSuggestion;
  }

  return comment;
}
